import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { createElement } from 'react';

/**
 * Shared QueryClient singleton.
 *
 * Defaults are intentionally conservative — staleTime keeps fetched data
 * fresh for 30 s so fast page transitions don't re-fetch, while
 * refetchOnWindowFocus ensures a tab-switch picks up mutations made in
 * another tab or by a background workflow.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,       // 30 s — data considered fresh
      gcTime: 5 * 60_000,      // 5 min — unused cache entries collected
      retry: 1,                // one automatic retry on failure
      refetchOnWindowFocus: true,
    },
  },
});

/**
 * App-level provider — wrap the router tree in this so every page shares
 * the same query cache and invalidation surface.
 */
export function AppQueryProvider({ children }: { children: ReactNode }) {
  return createElement(QueryClientProvider, { client: queryClient }, children);
}
